import {Image} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/image.types';
import React from 'react';
import {HeroContentProps} from './HeroContent';
import {HeroContentDeferred} from './HeroContentDeferred';
import {HeroContentView} from './HeroContentView';

export interface HeroContentProductsProps
  extends Omit<
    HeroContentProps,
    | 'className'
    | 'coverPortraitImage'
    | 'coverLandscapeImage'
    | 'coverPortraitVideo'
    | 'coverLandscapeVideo'
  > {
  image: Image;
  onProductListSwipe?: VoidFunction;
}

export const HeroContentSwitch: React.FC<HeroContentProductsProps> = ({
  content,
  discoverMore,
  ...rest
}) => {
  if (!content) {
    return null;
  }

  if (content?.$case === 'products') {
    return (
      <HeroContentView
        products={content.products}
        discoverMore={discoverMore}
        {...rest}
      />
    );
  }

  return (
    <HeroContentDeferred
      deferred={content.deferred}
      discoverMore={discoverMore}
      {...rest}
    />
  );
};
